import { unzipSync } from 'fflate';
const OPFS_ROOT_DIR = 'ograf-packages';
export class OgrafStore {
    rootHandle;
    async getRoot() {
        if (!this.rootHandle) {
            const opfs = await navigator.storage.getDirectory();
            this.rootHandle = await opfs.getDirectoryHandle(OPFS_ROOT_DIR, {
                create: true,
            });
        }
        return this.rootHandle;
    }
    async storePackage(id, files) {
        const root = await this.getRoot();
        const pkgDir = await root.getDirectoryHandle(id, { create: true });
        for (const [path, data] of files) {
            const parts = path.split('/').filter(Boolean);
            let dir = pkgDir;
            for (let i = 0; i < parts.length - 1; i++) {
                dir = await dir.getDirectoryHandle(parts[i], { create: true });
            }
            const fileName = parts[parts.length - 1];
            const fileHandle = await dir.getFileHandle(fileName, {
                create: true,
            });
            const writable = await fileHandle.createWritable();
            await writable.write(data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength));
            await writable.close();
        }
    }
    async getFile(id, path) {
        const root = await this.getRoot();
        const pkgDir = await root.getDirectoryHandle(id);
        const parts = path.split('/').filter(Boolean);
        let dir = pkgDir;
        for (let i = 0; i < parts.length - 1; i++) {
            dir = await dir.getDirectoryHandle(parts[i]);
        }
        const fileHandle = await dir.getFileHandle(parts[parts.length - 1]);
        const file = await fileHandle.getFile();
        return new Uint8Array(await file.arrayBuffer());
    }
    async removePackage(id) {
        const root = await this.getRoot();
        await root.removeEntry(id, { recursive: true });
    }
    async listPackageIds() {
        const root = await this.getRoot();
        const ids = [];
        for await (const [name, handle] of root) {
            if (handle.kind === 'directory') {
                ids.push(name);
            }
        }
        return ids;
    }
    async findManifest(id) {
        const root = await this.getRoot();
        const pkgDir = await root.getDirectoryHandle(id);
        return this.searchForManifest(pkgDir, '');
    }
    async searchForManifest(dir, prefix) {
        for await (const [name, handle] of dir) {
            const fullPath = prefix ? `${prefix}/${name}` : name;
            if (handle.kind === 'file' && name.endsWith('.ograf.json')) {
                const file = await handle.getFile();
                const content = await file.text();
                return { path: fullPath, content };
            }
            if (handle.kind === 'directory') {
                const result = await this.searchForManifest(handle, fullPath);
                if (result)
                    return result;
            }
        }
        return undefined;
    }
    static extractZip(file) {
        return file.arrayBuffer().then((buffer) => {
            const entries = unzipSync(new Uint8Array(buffer));
            const files = new Map();
            for (const [path, data] of Object.entries(entries)) {
                if (!path.endsWith('/')) {
                    files.set(path, data);
                }
            }
            return files;
        });
    }
    static async readDirectory(handle) {
        const files = new Map();
        await OgrafStore.readDirectoryRecursive(handle, '', files);
        return files;
    }
    static async readDirectoryRecursive(dir, prefix, files) {
        for await (const [name, handle] of dir) {
            const fullPath = prefix ? `${prefix}/${name}` : name;
            if (handle.kind === 'file') {
                const file = await handle.getFile();
                files.set(fullPath, new Uint8Array(await file.arrayBuffer()));
            }
            else if (handle.kind === 'directory') {
                await OgrafStore.readDirectoryRecursive(handle, fullPath, files);
            }
        }
    }
}
